import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Button } from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";

import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import PelaporanPageHeader from "../../components/Headers/PelaporanPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

const PelaporanPage = () => {
    const [data, setData] = useState({
        deskripsi: "",
        foto_cover: "",
        foto_wbs: "",
        dokumen: "",
    });

    useEffect(() => {
        AOS.init();
        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");

        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/pelaporan/readPelaporan`
                );

                if (response.data.length > 0) {
                    setData(response.data[0]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

        return () => {
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    return (
        <>
            <ExamplesNavbar />
            <PelaporanPageHeader />

            <div className="wrapper">
                <section className="sec__one governance wbs-section">
                    <Container className="flex mtop wbs">
                        {/* ========== COVER IMAGE ========== */}
                        <Row className="spanduk-container justify-content-center">
                            <Col lg="12" data-aos="fade-right">
                                {data.foto_cover && (
                                    <img
                                        src={data.foto_cover}
                                        alt="Cover"
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "10px",
                                            marginTop: "50px",
                                            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                        }}
                                    />
                                )}
                            </Col>
                        </Row>

                        {/* ========== LOGO + DESKRIPSI ========== */}
                        <Row className="my-4 d-flex align-items-center">
                            <Col lg="4" md="12" className="text-center" data-aos="fade-right">
                                {data.foto_wbs && (
                                    <img
                                        src={data.foto_wbs}
                                        alt="WBS Logo"
                                        style={{
                                            width: "100%",
                                            maxWidth: "500px",
                                            borderRadius: "10px",
                                        }}
                                    />
                                )}
                            </Col>

                            <Col lg="8" md="12" data-aos="fade-left">
                                <h2 className="text-center">Whistle Blowing System</h2>

                                <p style={{ fontSize: "18px", lineHeight: "1.7" }}>
                                    {data.deskripsi}
                                </p>

                                <p>
                                    Pelapor dapat menyampaikan laporan dugaan pelanggaran melalui
                                    saluran resmi yang tersedia:
                                </p>

                                {/* EMAIL */}
                                <div className="contactwbs my-3">
                                    <div className="container-wbs d-flex align-items-center">
                                        <i
                                            className="fas fa-envelope"
                                            style={{ fontSize: "25px", paddingRight: "10px" }}
                                        ></i>

                                        <a
                                            href="mailto:gcg-ykbutgroup@ykbut.co.id"
                                            style={{ fontSize: "17px" }}
                                        >
                                            gcg-ykbutgroup@ykbut.co.id
                                        </a>
                                    </div>
                                </div>

                                {/* BUTTON */}
                                <div className="container-button my-3 d-flex justify-content-center">
                                    {data.dokumen && (
                                        <a
                                            href={data.dokumen}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Button color="primary" className="primary-btn mx-2">
                                                Baca Dokumen
                                            </Button>
                                        </a>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <DefaultFooter />
            </div>
        </>
    );
};

export default PelaporanPage;
